import { render } from "./ContentsInfo.vue?vue&type=template&id=471a9481&scoped=true&ts=true"
import script from "./ContentsInfo.vue?vue&type=script&lang=ts"
export * from "./ContentsInfo.vue?vue&type=script&lang=ts"

import "./ContentsInfo.vue?vue&type=style&index=0&id=471a9481&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-471a9481"]])

export default __exports__